export default "__VITE_ASSET__DYVMyuzn__"